import { coverLayoutTexts, type CoverTextBox } from 'fym-shared/src/music24/coverDoc';
import type { ReleaseThemeId } from 'fym-shared/src/music24/releaseThemes';

/** The fields of a box that the theme sets. The place, the size and the text stay with the user. */
export type ThemeTextStyle = Pick<
  CoverTextBox,
  | 'fontId'
  | 'weight'
  | 'italic'
  | 'colour'
  | 'opacity'
  | 'textCase'
  | 'tracking'
  | 'lineHeight'
  | 'shadow'
  | 'outline'
  | 'glow'
>;

/**
 * "Reset to theme" of the text inspector: the font, the weight, the case, the letter spacing, the
 * colour and the shadow that a new box of this role gets in the release theme (`coverLayoutTexts`).
 * A free box takes the style of the artist line. Pure.
 */
export function themeTextStyle(
  role: CoverTextBox['role'],
  themeId: ReleaseThemeId,
  palette: readonly string[]
): ThemeTextStyle | null {
  // The texts only make the boxes; their words do not matter here.
  const boxes = coverLayoutTexts({ layout: 'bottom', themeId, palette, title: 'T', artist: 'A' });
  const source = boxes.find((box) => box.role === (role === 'title' ? 'title' : 'artist'));
  if (source === undefined) {
    return null;
  }
  const { fontId, weight, italic, colour, opacity, textCase, tracking, lineHeight, shadow, outline, glow } = source;
  return { fontId, weight, italic, colour, opacity, textCase, tracking, lineHeight, shadow, outline, glow };
}
